import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

let platform = 'web';
if (typeof window !== 'undefined') {
  platform = Capacitor.getPlatform();
}

if (
  process.env.NX_SENTRY_DSN !== undefined &&
  process.env.NX_SENTRY_DSN !== ''
) {
  Sentry.init({
    dsn: process.env.NX_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    // Reduce from 1.0 to capture only 10% of transactions
    tracesSampleRate: 0.1,
    tracePropagationTargets: [
      /^\//,
      new RegExp(`^https://${window.location.hostname}/api`),
    ],
    // Reduce session replay sampling
    replaysSessionSampleRate: 0.01, // 1% of sessions
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NX_ENVIRONMENT,
    release: `membertraxx-react-app@${
      process.env.npm_package_version ?? 'unknown'
    }`,
    // Add before send to filter out noise
    beforeSend(event, hint) {
      // Filter out non-critical errors if needed
      return event;
    },
  });
  Sentry.setTag('platform', platform);
}
